import { ComponentChild, h } from 'preact'
import LazyLoader from '../../lazy-loading/LazyLoader'

interface Props {
  idx: number
  key?: number
  title: string
  customClass?: string
  metadata?: ComponentChild
  navigation?: {
    url: string
    target?: '_blank'
  }
  imageSrc?: string
  position?: 'vertical' | 'horizontal'
}

const Card = ({ customClass, navigation, title, imageSrc, metadata, idx, position = 'vertical' }: Props) => {
  return (
    <article
      className={`o-card o-card-${position} ${customClass ?? ''}`}
    >
      {
          navigation
            ? (
              <a href={navigation.url} className={`m-card_url m-card-${position}`} target={navigation?.target}>
                {imageSrc
                  ? (
                    <figure className='a-card-image'>
                      <LazyLoader
                        type='background'
                        src={imageSrc}
                        alt={`Community category image ${idx + 1}`}
                      />
                    </figure>
                    )
                  : null}
                <div className='m-card_info'>
                  <header><h3 className='a-card_info__title a-card-widget-title'>{title}</h3></header>
                  {
                        metadata
                          ? (
                            <p className='text--meta a-card-info__metadata'>
                              {metadata}
                            </p>
                            )
                          : null
                      }
                </div>
              </a>
              )
            : null
        }
    </article>
  )
}

export default Card
